import { Toaster as SonnerToaster } from "@/components/ui/sonner";

export const PageHeader = ({ title, subtitle, actions, testid }) => (
  <div className="flex flex-col items-stretch gap-4 mb-6 sm:mb-8 sm:flex-row sm:items-start sm:justify-between" data-testid={testid}>
    <div className="min-w-0">
      <div className="label-mini mb-2">{subtitle}</div>
      <h1 className="h-display text-2xl sm:text-4xl font-black tracking-tighter break-words">{title}</h1>
    </div>
    {actions && <div className="flex items-center gap-2 flex-wrap shrink-0">{actions}</div>}
  </div>
);

export const StatCard = ({ label, value, tone, testid, hint }) => {
  const toneColor =
    tone === "pos" ? "text-[#008A5E]" :
    tone === "neg" ? "text-[#D32F2F]" :
    tone === "warn" ? "text-[#B45309]" :
    "text-neutral-900";
  return (
    <div className="card-flat p-4 sm:p-6 min-w-0" data-testid={testid}>
      <div className="label-mini mb-3">{label}</div>
      <div className={`stat-value text-3xl ${toneColor}`}>{value}</div>
      {hint && <div className="text-xs text-neutral-500 mt-2">{hint}</div>}
    </div>
  );
};

export const AppToaster = () => (
  <SonnerToaster position="top-right" richColors closeButton />
);
